export function SetOpenModalGenerico(item) {
    return {
        type: 'SET_OPEN_MODAL_GENERICO',
        payload:{
            item
        }
    }
}